import Service from "./Service";
import {isEmpty} from 'lodash';
const baseurl = '/api/vacunas';
export default {
    index(params={}) {
        return Service.get(`${baseurl}`,{
            params: params
        });
    },
    store(obj) {
        return Service.post(`${baseurl}/store`, obj);
    },
    show(id) {
        return Service.get(`${baseurl}/show/${id}`);
    },
    update(obj) {
        return Service.put(`${baseurl}/update`, obj);
    },
    delete(id) {
        return Service.delete(`${baseurl}/delete/${id}`);
    },
    async allVacunas(search = '',pagination = {}) {
        let url = `${baseurl}/all-vacunas?`;

        url += search !== '' ? `s=${search}` : '';

        url += (!isEmpty(pagination))
            ? `&paginate=true&per_page=${pagination.per_page}&page=${pagination.page}`
            : '';

        return Service.get(url);
    },
    search(s){
        return Service.get(`${baseurl}/data-source-vacuna?s=${escape(s)}`);
    },
    search_by_sede(s,id_sede_origen){
        return Service.get(`${baseurl}/data-source-vacuna-by-sede?s=${escape(s)}&id_sede_origen=${id_sede_origen}`);
    },
}